export enum StyleType {
  default = "default",
  flashy = "flashy"
  // TODO "primary"|"secondary"|"info"|"warning"|"danger"
}
